var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSock02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#000;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1460.1 349.7H1067v113.5h393.3V349.7z",
    id: "Layer_3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.6 1331.6c51.3 88.7 147.1 254.7 202.2 350.4l-6.3 2.9c-101.5 46.3-221.3 1.9-268.1-99.4-42.5-92.1-10.1-199.7 72.2-253.9zm685.3 129.7l79.2-36.2c88.5-40.4 145.3-128.8 145.3-226.1v-41.2H1236v303.5zM1067 216.8v132.9h393.4V218.5l-393.4-1.7zm393.1 246.4h-393.2v113.5h393.4V463.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1460.3 576.7v581.1h-224.5v303.5l-483.1 220.6c-55.1-95.7-150.8-261.7-202.2-350.4 7.9-5.2 16.2-9.9 24.9-14.1l420.2-199.3c43.5-20.6 71.2-64.5 71.2-112.6V576.7h393.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1067.7 349.7h392.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1067.7 463.2h392.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1067.7 576.7h392.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M752.8 1681.9l483-220.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1460.3 1157.8V218.5l-393.3-1.7v788.8c0 48.2-27.7 92-71.2 112.6l-420.2 199.3c-8.8 4.2-17.1 8.9-24.9 14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1235.8 1461.3l79.2-36.2c88.5-40.4 145.3-128.8 145.3-226.1v-41.2h-224.5v303.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M550.6 1331.6c-82.3 54.3-114.7 161.8-72.2 253.9 46.8 101.3 166.6 145.7 268.1 99.4l6.3-2.9c-55.2-95.7-150.9-261.8-202.2-350.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSock02);
export default __webpack_public_path__ + "static/media/sock-02.d0c6b6371c8adcb30313afcb57117c9a.svg";
export { ForwardRef as ReactComponent };